import React, { useRef, useState } from 'react'
import {
  ButtonToolbar,
  Col,
  Form,
  Image,
  InputGroup,
  OverlayTrigger,
  Row,
  Table,
  Tooltip
} from 'react-bootstrap'
import NavTitle from '../../../components/nav-title'
import NavRoleOrg from '../../../components/nav-role-org'
import { BsPlusLg, BsSearch } from 'react-icons/bs'
import editImg from '../../../images/Provident-Fund/Edit_Fill.svg'
import editImgs from '../../../images/Provident-Fund/Edit_Fill-secondary.svg'
import { InputNumber, Select } from 'antd'
import Button from 'react-bootstrap/Button'
import imgUser from '../../../images/user.png'
import {
  editProvidentFundAPI,
  getProvidentFundAPI
} from '../../../services/provident-fund'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import Error_false from '../../../components/error/error-false'
import { Controller, useForm } from 'react-hook-form'
import DatepickerCustom from '../../../components/datepicker-custom'
import { useDebounce } from '@react-hook/debounce'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import ModalCustom from '../../../components/modal-custom'
import CardCustom from '../../../components/custom/card-custom'
import SwalCustom from '../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../Constants'
import UseTypeOfFund from '../../../components/employees/pvd/pvd-select-type'
import TextNavTitle from '../../../components/TextNavTitle'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import SpinnerLoading from '../../../components/spinner-loading'
import Error_500 from '../../../components/error/error-500'
import useNumberInput from '../../../helper/input-fix-num'
import { fnDateEn } from '../../../helper/fnDateEn'
import ExportExcelPVD from '../../../components/employees/pvd/export-excel'
import ModalAddMember from '../../../components/employees/pvd/ModalAddMember'
import Autocomplete from '../../../components/custom/autocomplete'
import UsePVDStatus from '../../../hooks/use-pvd-status'

export default function PvdPage() {
  const [isModalOpenAddMember, setIsModalOpenAddMember] = useState(false)
  const optionStatusPvd = UsePVDStatus()
  const schema = yup
    .object({
      ...(isModalOpenAddMember
        ? {
            name: yup.object().required('โปรดระบุข้อมูล'),
            startDateAdd: yup.string().required('โปรดระบุข้อมูล'),
            percentageAdd: yup.string().required('โปรดระบุข้อมูล')
            // planNameAdd: yup.string().required('โปรดระบุข้อมูล')
          }
        : {})
    })
    .required()
  const { control, setValue, handleSubmit, setError } = useForm({
    resolver: yupResolver(schema)
  })
  const orgId = useSelector((state) => state.roleReducer.role)
  const [page, setPage] = useState(1)
  const [totalRows, setTotalRows] = useState(0)
  const [totalLimits, setTotalLimits] = useState(20)
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false)
  const [dataTable, setdataTable] = useState([])
  const [onSelect, setOnSelect] = useState(null)
  const [percentageA, setPercentageA] = useState()
  const [dataResult, setDataResult] = useState()
  const [search, setSearch] = useDebounce('', 1000)
  const TypePlan = UseTypeOfFund()
  const selectedFundType = TypePlan.find((item) => item.value === onSelect)
  const [isLoading, setIsLoading] = useState(false)
  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)

  const [bodyFilter, setBodyFilter] = useState()
  const handleChange = (value) => {
    setOnSelect(value)
  }

  useEffect(() => {
    if (orgId) {
      const body = {
        ...bodyFilter,
        page: 1,
        orgId,
        size: totalLimits,
        searchs: search
      }
      setPage(1)
      getProvidentFund(body)
    }
  }, [orgId, search])

  const getProvidentFund = async (body) => {
    try {
      setBodyFilter(body)
      const result = await getProvidentFundAPI(body)
      setIsLoading(false)

      if (!result) return
      if (result.status) {
        setdataTable(result.result)
        setTotalRows(result.totalRows)
        setTotalLimits(result.totalLimits)
      } else {
        Error_false(result)
      }
    } catch (error) {
      setIsLoading(false)
      Error_500(error)
    }
  }

  //onSubmit edit
  const onSubmitEdit = (d) => {
    const body = {
      percent: percentageA ?? d?.percentageEdit ?? '',
      startDate: d?.startDateEdit,
      endDate: d?.endDateEdit,
      planId: d?.planName ?? selectedFundType?.id ?? ''
    }
    const paramEdit = {
      code: dataResult.code,
      orgId,
      pvdId: dataResult.id,
      username: dataResult.username
    }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to save the changes?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        editProvidentFund(paramEdit, body)
      }
    })
  }

  //edit function
  const editProvidentFund = async (param, body) => {
    const result = await editProvidentFundAPI(param, body)
    if (!result) return
    if (result.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        getProvidentFund(bodyFilter)
      })
    } else {
      Error_false(result)
    }
    setIsModalOpenEdit(false)
  }

  const handleCancelEdit = () => {
    setIsModalOpenEdit(false)
  }

  const showModalEdit = (d) => {
    setValue('percentageEdit', d?.percent)
    setValue('planName', d?.plan_id)
    setValue('startDateEdit', d?.start_date)
    setValue('endDateEdit', d?.end_date)
    setOnSelect(null)
    setDataResult(d)
    setIsModalOpenEdit(true)
  }

  const showModalAddMember = () => {
    setOnSelect(undefined)
    setIsModalOpenAddMember(true)
  }

  const handleCancelAddMember = () => {
    setIsModalOpenAddMember(false)
  }

  const [pvdStatus, setPvdStatus] = useState()

  const onSelectStatus = (id) => {
    setPage(1)
    const body = {
      ...bodyFilter,
      page: 1,
      pvdStatus: id ?? ''
    }
    getProvidentFund(body)
  }

  return (
    <Row>
      <NavTitle>
        <TextNavTitle>กองทุนสำรองเลี้ยงชีพ (PVD)</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <Col xl={12} className="mb-3">
        <CardCustom
          minHeight=""
          style={{
            height: 'calc(100vh - 130px'
          }}
        >
          <Row className="p-3">
            <Col
              xl={12}
              className="my-auto d-flex gap-3 justify-content-between"
              style={{ flexWrap: 'wrap' }}
            >
              <label
                style={{ flexWrap: 'wrap' }}
                className="small my-auto fw-bold "
              >
                Total: {totalRows}
              </label>
              <div className="d-flex gap-2">
                <div style={{ minWidth: 180 }}>
                  <Autocomplete
                    placeholder="PVD Status"
                    className="w-100"
                    isClearable={true}
                    value={pvdStatus}
                    options={optionStatusPvd}
                    onChange={(e) => {
                      setPvdStatus(e)
                      onSelectStatus(e?.value)
                    }}
                  />
                </div>
                <Form.Group className="" style={{ minWidth: 300 }}>
                  <InputGroup className="">
                    <InputGroup.Text className="bg-white border-end-0  text-muted">
                      <BsSearch />
                    </InputGroup.Text>
                    <Form.Control
                      className="border-start-0 ps-0"
                      placeholder="Code/ Name"
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </InputGroup>
                </Form.Group>

                <Button
                  size="sm"
                  className="px-3 btn btn-sm btn-primary border-0"
                  onClick={showModalAddMember}
                >
                  <BsPlusLg /> Add Member
                </Button>

                <ExportExcelPVD bodyFilter={bodyFilter} totalRows={totalRows} />
              </div>
            </Col>
          </Row>
          <Table hover className="mb-3" responsive>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className="fw-light font-title-table">
                <th
                  className="fw-normal text-center"
                  style={{
                    minWidth: '2rem',
                    top: '0px',
                    position: 'sticky'
                  }}
                >
                  #
                </th>
                <th className="fw-normal text-center">Image</th>
                <th
                  className="fw-normal "
                  style={{
                    top: '0px',
                    position: 'sticky'
                  }}
                >
                  Code
                </th>
                <th className="fw-normal">Name</th>
                <th className="fw-normal text-center">Fund Entry Date</th>
                <th className="fw-normal text-center">Type of Fund</th>
                <th className="fw-normal text-center">% Deducted</th>
                <th className="fw-normal text-center">Resignation Date</th>{' '}
                <th className="fw-normal text-center">Round</th>
                <th className="fw-normal text-center">Status</th>
                <th className="fw-normal text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr className="mb-0">
                  <td className="text-center" colSpan={10}>
                    <SpinnerLoading />
                  </td>
                </tr>
              ) : (
                <>
                  {dataTable.length > 0 ? (
                    dataTable.map((d, i) => (
                      <tr key={i} className="fw-light font-small-2  ">
                        <td className="text-center">
                          {' '}
                          {page * totalLimits - totalLimits + i + 1}{' '}
                        </td>
                        <td className=" text-center">
                          <Image
                            fluid
                            className="rounded-circle "
                            style={{
                              maxWidth: 40,
                              maxHeight: 40,
                              objectFit: 'cover'
                            }}
                            src={`${d?.img_url}`}
                            disable={imgUser}
                            onError={(event) => {
                              event.target.src = imgUser
                              event.onerror = null
                            }}
                          />
                        </td>
                        <td className="">{d?.code}</td>

                        <td>
                          <p className="mt-0 ">
                            {d?.title_th}
                            {d?.name_th} {d?.surname_th}{' '}
                          </p>
                        </td>

                        <td className="text-center ">
                          {fnDateEn(d?.start_date).format('DD/MM/YYYY')}
                        </td>
                        <td className="text-center ">{d?.plan_name ?? '-'}</td>
                        <td className="text-center ">{d?.percent + '%'} </td>
                        <td className="text-center ">
                          {d?.end_date === null ? (
                            <> - </>
                          ) : (
                            <> {fnDateEn(d?.end_date).format('DD/MM/YYYY')} </>
                          )}
                        </td>

                        <td className="text-center ">{d?.type_name ?? '-'}</td>
                        <td className="text-center ">
                          <span
                            style={{
                              color:
                                d.status_id === 1
                                  ? '#009b47'
                                  : d.status_id === 3
                                    ? '#f0cb00'
                                    : '#989898'
                            }}
                          >
                            {d?.status_name ?? '-'}
                          </span>
                        </td>
                        <td className="text-center">
                          {d?.status_id === 1 ? (
                            <ButtonToolbar className="d-flex justify-content-center">
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-detail">Edit</Tooltip>
                                }
                              >
                                <Button
                                  variant="btn btn-outline-primary"
                                  className="border-0 "
                                  size="sm"
                                  style={{
                                    width: '32px',
                                    height: '32px'
                                  }}
                                  onClick={() => showModalEdit(d)}
                                  // className="pointer-event"
                                >
                                  <Image src={editImg} />
                                </Button>
                              </OverlayTrigger>
                            </ButtonToolbar>
                          ) : (
                            <Image src={editImgs} />
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="mb-0">
                      <td className="text-center small" colSpan={13}>
                        {orgId
                          ? '- ไม่มีข้อมูล -'
                          : '- ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT -'}
                      </td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </Table>
          <div className=" pt-3">
            <PaginationControl
              page={page}
              total={totalRows}
              limit={totalLimits}
              changePage={(p) => {
                const body = {
                  ...bodyFilter,
                  page: p
                }
                getProvidentFund(body)
                setPage(p)
              }}
              ellipsis={1}
            />
          </div>
        </CardCustom>
      </Col>

      {/* Add Member */}

      {isModalOpenAddMember && (
        <ModalAddMember
          isShow={isModalOpenAddMember}
          onCancel={handleCancelAddMember}
          orgId={orgId}
          TypePlan={TypePlan}
          fnGetData={() => getProvidentFund(bodyFilter)}
        />
      )}

      {/* Edit Member */}
      <ModalCustom open={isModalOpenEdit} onCancel={handleCancelEdit}>
        <Col xl={12}>
          <Row>
            <Form onSubmit={handleSubmit(onSubmitEdit)}>
              <div
                className="fw-normal text-primary mt-2"
                style={{
                  fontSize: '20px',
                  marginLeft: '15px'
                }}
              >
                Edit Member
              </div>
              <div className="row mt-2">
                <div className="fw-normal col-6 p-4 pb-3">
                  <div className="p-1"> % Deducted</div>

                  <Controller
                    name="percentageEdit"
                    control={control}
                    render={({ field }) => (
                      <InputNumber
                        className="w-100"
                        min={1}
                        max={15}
                        value={field.value}
                        formatter={(value) => `${value}%`}
                        parser={(value) => value.replace('%', '')}
                        onChange={(value) => {
                          field.onChange(value)
                          setPercentageA(value)
                        }}
                        onKeyDown={handleKeyDownNum}
                      />
                    )}
                  />
                </div>
                <div className="fw-normal col-5 pt-0 p-2 m-3 mb-0 mt-4 pb-0">
                  <div className="p-1"> Type of Fund </div>

                  <Controller
                    name="planName"
                    control={control}
                    render={({ field }) => (
                      <Select
                        className="w-100"
                        allowClear
                        options={TypePlan}
                        value={field.value}
                        onChange={(selectedValue) => {
                          field.onChange(selectedValue)
                          handleChange(selectedValue)
                        }}
                      />
                    )}
                  />
                </div>
                <div className="fw-normal col-6 p-4 pb-3">
                  <div className="p-1">Fund Entry Date</div>
                  <Controller
                    name={'startDateEdit'}
                    control={control}
                    render={({ field: { value = '' } }) => (
                      <DatepickerCustom
                        value={value}
                        onChange={([date]) => {
                          setValue(
                            'startDateEdit',
                            date ? fnDateEn(date).format('YYYY-MM-DD') : ''
                          )
                          setError('startDateEdit', date)
                        }}
                      />
                    )}
                  />
                </div>
                <div className="fw-normal col-6 p-4 pb-3">
                  <div className="p-1">Resignation Date</div>
                  <Controller
                    name={'endDateEdit'}
                    control={control}
                    render={({ field: { value = '' } }) => (
                      <DatepickerCustom
                        value={value}
                        onChange={([date]) => {
                          // setEndDateEdit(fnDateEn(date).format("DD/MM/YYYY"));
                          setValue(
                            'endDateEdit',
                            date ? fnDateEn(date).format('YYYY-MM-DD') : ''
                          )
                          setError('endDateEdit', date)
                        }}
                      />
                    )}
                  />
                </div>
                <div className="col-12 mt-5 d-flex gap-3 justify-content-center">
                  <Button
                    variant="outline-primary"
                    style={{
                      width: '130px'
                    }}
                    size="sm"
                    className="rounded-3"
                    onClick={handleCancelEdit}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="primary"
                    type="submit"
                    style={{
                      width: '130px'
                    }}
                    size="sm"
                    className="rounded-3"
                  >
                    Apply
                  </Button>
                </div>
              </div>{' '}
            </Form>
          </Row>
        </Col>
      </ModalCustom>
    </Row>
  )
}
